class FacetLoader
  constructor: (allFacets, searchFacets)->
    @allFacets = allFacets
    @searchFacets = searchFacets || {}
    @loadedFacets = {}
    @allLoadedFacets = {}
    @remainingLoadedFacets = {}
    @minDeals = 4
    @facetToFilter = # this will map GAPI facets to RAPI counterparts
      category2: 'subcategory'
      category3: 'subcategory2'

    @alphaSort = (a, b) ->
      return (a.name || a.id || '').localeCompare(b.name)

    @facetSort = (a, b) ->
      if a.parentOrder || b.parentOrder
        if a.parentOrder && !b.parentOrder
          return (a.parentOrder + 0.001) - b.order
        else if b.parentOrder && !a.parentOrder
          return a.order - (b.parentOrder + 0.001)
        else if a.parentOrder != b.parentOrder
            return a.parentOrder - b.parentOrder
      return a.order - b.order

    @loadFacets = (facets, facetLevelTypes, level, optionalParent) ->
      optionalParent = optionalParent || {}

      for facet in facets
        for facetSearchId of @searchFacets
          searchMeta = @searchFacets[facetSearchId]
          if facet.count >= searchMeta.require
            seekFacets = searchMeta.seekFacets
            levelType = facetLevelTypes[level]
            ordering = seekFacets[facet.id]
            if not ordering and seekFacets[levelType]
              ordering = 10000 + (facet.distance || (level + seekFacets[levelType]) * -facet.count) || 1
              facet.order = ordering
            if ordering
              @loadedFacets[facetSearchId].push
                category: facet.id
                id: facet.id
                count: facet.count
                order: ordering
                name: facet.friendlyNameShort or facet.friendlyName
                level: level
                type: levelType
                parentOrder: optionalParent.order
                query: levelType + ':' + facet.id
        if facet.children and facet.children.length
          @loadFacets facet.children, facetLevelTypes, level+1, facet

    @processFacetConfig = () ->
      for facetSearchId of @searchFacets
        @loadedFacets[facetSearchId] = []
        searchMeta = @searchFacets[facetSearchId]
        searchMeta.require = searchMeta.require || @minDeals
        if not searchMeta.searchList
          searchMeta.searchList = searchMeta.search.split(',')
        searchMeta.max = Math.max(searchMeta.max||10, searchMeta.searchList.length)
        order = 1
        searchMeta.seekFacets = []
        for facet in searchMeta.searchList
          facet = @facetToFilter[facet] ? facet
          searchMeta.seekFacets[facet] = order++
      if @allFacets and @allFacets.length 
        for facet in @allFacets
          facetLevelTypes = facet.id.split('|')
          for type, ind in facetLevelTypes
            facetLevelTypes[ind] = @facetToFilter[type] ? type
          facetLevel = 0
          @loadFacets(facet.values, facetLevelTypes, facetLevel)
        for facetSearchId of @searchFacets
          @loadedFacets[facetSearchId].sort(@facetSort)
          searchMeta = @searchFacets[facetSearchId]
          @allLoadedFacets[facetSearchId] = @loadedFacets[facetSearchId]
          @remainingLoadedFacets[facetSearchId] = @loadedFacets[facetSearchId].slice(searchMeta.max)
          @loadedFacets[facetSearchId] = @loadedFacets[facetSearchId].slice(0, searchMeta.max)

    @getCategories = (facetSearchId) ->
      {foundCats: @loadedFacets[facetSearchId] || []}

    @processFacetConfig()

module.exports = FacetLoader
